import React from 'react'
import PropTypes from 'prop-types'
import StandardDialog from 'components/common/standard_dialog'
import { withRouter } from 'react-router'
import { routerShape } from 'react-router/lib/PropTypes'
import { appendPath } from 'lib/route_utils'
import { getI18n } from 'client/i18n'
import { fromVeniceSelector } from 'redux/selectors/venice'

const i18n = getI18n('components/edit_glimpse/edit_main')

class EditForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    router: routerShape.isRequired,
    route: PropTypes.any,
    children: PropTypes.any,
    dirty: PropTypes.bool,
    operatingRemotely: PropTypes.bool,
    stepRef: PropTypes.func,
    mobile_app: PropTypes.any,
  }

  state = { showBackDialog: false, callback: null }

  handleSubmit = formValues => {
    return this.props
      .onSave(formValues)
      .then(() => {
        const {
          params: { hideBack = false, campaignId = '' } = {},
        } = this.props.router
        // Only support returning back to edit route if the user is Venice and
        // there is no back option. All other use cases can be handled with history
        if (fromVeniceSelector()(this.props) && hideBack) {
          this.props.router.push({ pathname: `/pools/c/${campaignId}/edit` })
        } else {
          this.props.router.goBack()
        }
      })
      .catch(err => {
        console.error(err) // eslint-disable-line no-console
        this.props.router.push({
          pathname: appendPath(location.pathname, 'error'),
          state: { updateData: err.updateData },
        })
      })
  }

  handleDialogClose = () => {
    this.state.callback(false)
    this.setState({ showBackDialog: false, callback: null })
  }

  handleDialogOk = () => {
    this.state.callback(true)
  }

  componentDidMount() {
    if (this.props.stepRef) {
      this.props.stepRef(this)
    }
  }

  confirmNavigation = callback => {
    if (this.props.dirty) {
      this.setState({ showBackDialog: true, callback })
    } else {
      callback(true) // eslint-disable-line callback-return
    }
  }

  render() {
    const { handleSubmit } = this.props

    return (
      <div>
        {this.state.showBackDialog && (
          <StandardDialog
            size="medium"
            title={i18n('dirty_dialog_title')}
            subtitle={i18n('dirty_dialog_subtitle')}
            closeButtonTitle={i18n('keep_editing')}
            okButtonTitle={i18n('quit')}
            onClose={this.handleDialogClose}
            onOk={this.handleDialogOk}
          />
        )}
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          {this.props.children}
        </form>
      </div>
    )
  }
}

export default withRouter(EditForm)
